import React, { useEffect } from 'react'
import pic from '../images/heroPic.jpeg'
import { Helmet } from 'react-helmet';

const ContactUs = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='w-full mt-20 font-overpass'>
        <Helmet>
          <title>K-Mats | Contact Us</title>
        </Helmet>
      <div className='h-full w-full relative grid justify-center grid-cols-1 md:grid-cols-2 mt-10 sm:mt-10 md:mt-16 gap-8 md:gap-10'>
        {/* Info Panel */}
        <div className='mt-10 flex items-center justify-center'>
          <div className='mx-auto w-[80%] rounded-2xl border border-slate-200 bg-slate-50 p-8 shadow-sm'>
            <h1 className='text-4xl font-bold mb-3 text-black/80 '>Contact Us</h1>
            <p className='text-base text-slate-600 leading-relaxed'>We’re here to help with product questions, order support, shipping, and returns.</p>
            <div className='mt-8 space-y-5 text-slate-700'>
              <div>
                <p className='text-sm font-semibold uppercase tracking-wide text-cyan-700'>Australia</p>
                <p className='mt-1 text-lg font-semibold'>Kaye</p>
                <p>Hotline: 0061 403 370 767</p>
                <p>Email: sales@kmat.au.com</p>
              </div>
              <div>
                <p className='text-sm font-semibold uppercase tracking-wide text-cyan-700'>Sri Lanka</p>
                <p className='mt-1 text-lg font-semibold'>Sandaruwan</p>
                <p>Hotline: 071 661 6471</p>
                <p>Email: sales@kmat.au.com</p>
              </div>
            </div>
          </div>
        </div>

        {/* Details */}
        <div className='mt-16 md:mt-0 relative'>
          <div className='bg-black'>
            <img src={pic} alt="" className='w-full h-[550px] 2xl:h-full object-cover bg-black opacity-40'/>
          </div>
          <div className='mx-auto w-[80%] absolute top-0 left-5 mt-10'>
            <h1 className='text-4xl font-bold mb-5 text-white'>Our Company</h1>
            <div className='w-full'>
              <div>
                <h1 className='text-cyan-200 text-2xl font-semibold'>Address</h1>
                <p className='text-white text-lg font-semibold font-karla'>Brisbane</p>
              </div>
              <div className='text-white mt-8 md:mt-5'>
                <h1 className='text-cyan-200 text-2xl font-semibold'>Customer Hotlines (Australia)</h1>
                <p className='text-lg font-semibold font-karla'>Contact Name: Kaye</p>
                <p className='text-lg font-semibold font-karla'>HotLine: 0061403370767</p>
                <p className='text-lg font-semibold font-karla'>Email: sales@kmat.au.com</p>
              </div>
              <div className='text-white mt-8 md:mt-5'>
                <h1 className='text-cyan-200 text-2xl font-semibold'>Customer Hotlines (Sri Lanka)</h1>
                <p className='text-lg font-semibold font-karla'>Contact Name: Sandaruwan</p>
                <p className='text-lg font-semibold font-karla'>Hotline: 0716616471</p>
                <p className='text-lg font-semibold font-karla'>Email: sales@kmat.au.com</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default ContactUs
